export default __webpack_public_path__ + "static/media/flavio-bianchetti.7f326557.jpg";